import { LoaderType, NextgenImage } from '@nextgen-web-framework/all';
import type { TimelineCardsProps } from './types/propsTypes';
import styles from './TimelineCard.module.scss';

const TimelineCard = (props: TimelineCardsProps) => (
  <div className={styles['awards-timelines-tabs-item-wrapper']} data-testid={'awards-timelines-test-id'}>
    <div className={styles['awards-timelines-item-leftsection-image-wrapper']}>
      <NextgenImage
        src={props.url}
        alt={props.alt_text}
        className={styles['awards-timelines-item-leftsection-image']}
        loaderType={LoaderType.CONTENTSTACK}
      />
    </div>
    <div className={styles['awards-timelines-item-rightsection']}>
      <div className={styles['awards-timelines-item-title']}>{props.title}</div>
      <div className={styles['awards-timelines-item-description']}>{props.description}</div>
    </div>
  </div>
);
export default TimelineCard;
